import React from 'react'
import styles from './PrivacyPolicy.module.scss'
import PolicyDetails from './PolicyDetails'
import Layout from '../../components/Layout'
import Content from '../../components/Content'
import GeoProvider from '../../components/GeoProvider'
import SystemNotification from '../Dashboard/SystemNotification'
import PrivacyPolicyOneTrust from './PrivacyPolicyOneTrust'

const PrivacyPolicy = () => {
  return (
    <Layout>
      <Content>
        <GeoProvider>
          <SystemNotification />
        </GeoProvider>  
        <PrivacyPolicyOneTrust />
      </Content>
    </Layout>
  )
}

export default PrivacyPolicy
